import { commodityUrlFunction } from "app/commodities/url";
import { etfUrlFunction } from "app/etf/url";
import { fundUrlFunction } from "app/funds/url";
import { Instrument, urlFunction } from "app/main/types";
import { shareUrlFunction } from "app/shares/url";
import { stockIndexUrlFunction } from "app/stockIndexes/url";
import { ServerResponse } from "http";
import { exchangeRateUrlFunction } from "app/exchangeRates/url";
import { redirectToUrl } from "app/main/urls";

const instrumentUrlFunctions: {
    [x: string]: urlFunction;
} = {
    Share: shareUrlFunction,
    ETF: etfUrlFunction,
    Fund: fundUrlFunction,
    Index: stockIndexUrlFunction,
    Commodity: commodityUrlFunction,
    ExchangeRate: exchangeRateUrlFunction
};

export function getUrlForInstrument(type: string, isin: string, title: string) {
    try {
        if (instrumentUrlFunctions[type]) {
            return instrumentUrlFunctions[type](isin.toLowerCase(), title);
        }
    } catch (e) {
        return "/";
    }

    return "/";
}

export function createInstrumentRegexString(){
    return getUrlForInstrument("Share", ".+?", ".+?")
        .replace("/aktien/", "/.+?/")
        .replace("/--aktie/", "/.+?/");
}

export function isUrlForInstrument(url: string): boolean {
    return url.match(new RegExp(createInstrumentRegexString())) !== null;
}

/**
 * Cleans a given string so it can be used in a URL.
 * - converts all to lowercase
 * - converts umlauts (öäü, ß) to their equivalent (oe, ae...)
 * - replaces anything which is not a-z or 0-9 with "-"
 * - replaces multiple immediately following "-" with a single one
 * @param inString
 */
export const cleanStringForURL = (inString: string): string =>
    inString
        .toLowerCase()
        .replace(/ä/g, "ae")
        .replace(/ö/g, "oe")
        .replace(/ü/g, "ue")
        .replace(/ß/g, "ss")
        .replace(/[^a-z0-9-]/g, "-")
        .replace(/-+/g, "-");

const removeQueryParameters = (url: string) => url.split("?")[0];

/**
 * This function will match the current URL against the correct URL the instrument should use.
 * If the URL does not match, the client will be forwarded there.
 */
export function redirectOnWrongUrl(
    instrument: Instrument,
    actualURL: string = "",
    res: ServerResponse,
    urlPostfix = ""
): boolean {
    if (actualURL.substr(0, 7) === "/_next/") {
        return false;
    }

    const correctURL = getUrlForInstrument(instrument.assetClass, instrument.isin, instrument.name);

    if (removeQueryParameters(actualURL) !== `${correctURL}${urlPostfix}`) {
        redirectToUrl(res, correctURL, correctURL !== "/");
        return true;
    }

    return false;
}
